import { render, staticRenderFns } from "./DialogErrorApprove.vue?vue&type=template&id=600ea588&"
import script from "./DialogErrorApprove.vue?vue&type=script&lang=js&"
export * from "./DialogErrorApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports